<script setup>
import { computed } from 'vue'
import { getButtonColor } from '~/utils/colors'
import Icon from '@/components/Admin/Icon.vue'

const props = defineProps({
  label: {
    type: [String, Number],
    default: null
  },
  icon: {
    type: String,
    default: null
  },
  href: {
    type: String,
    default: null
  },
  target: {
    type: String,
    default: null
  },
  to: {
    type: [String, Object],
    default: null
  },
  type: {
    type: String,
    default: null
  },
  color: {
    type: String,
    default: 'white'
  },
  as: {
    type: String,
    default: null
  },
  sizeIcon: {
    type: [String, Number],
    default: 16
  },
  shape: {
    type: String,
    default: 'rounded'
  },
  small: Boolean,
  outline: Boolean,
  active: Boolean,
  disabled: Boolean
})

const is = computed(() => {
  if (props.as) {
    return props.as
  }

  if (props.to) {
    return 'router-link'
  }

  if (props.href) {
    return 'a'
  }

  return 'button'
})

const computedType = computed(() => {
  if (is.value === 'button') {
    return props.type ?? 'button'
  }

  return null
})
const router = useRouter();
const computedTo = computed(()=>{
 if(props.label==='Back'){
   return router.options?.history?.state?.back?? props.to?? props.href;
 }
 else return props.to?? props.href;
})

const labelClass = computed(() => props.small && props.icon ? 'px-1' : 'px-2')

const componentClass = computed(() => {
  const base = [
    'inline-flex',
    'cursor-pointer',
    'justify-center',
    'items-center',
    'whitespace-nowrap',
    'focus:outline-none',
    'transition-colors',
    'focus:ring',
    'duration-150',
    'border',
    'text-sm',
      'pageActive',
    props.active ? 'bg-sky-200' : '',
    props.small ? 'p-0.5' : 'p-0.5',
    props.shape,
    getButtonColor(props.color, props.outline, !props.disabled)
  ]

  if (props.disabled) {
    base.push('cursor-not-allowed', props.outline ? 'opacity-50' : 'opacity-70')
  }
  return base
})
</script>

<template>
  <NuxtLink
      v-if="to"
      :class="componentClass"
      :type="computedType"
      :to="computedTo"
      :target="target"
      :disabled="disabled"
  >
    <icon
        v-if="icon"
        :path="icon"
        :size="sizeIcon"
    />
    <span
        v-if="label"
        :class="labelClass"
    >{{ label }}</span>
  </NuxtLink>
  <component
      v-else
    :is="is"
    :class="componentClass"
    :href="href"
    :type="computedType"
    :to="to"
    :target="target"
    :disabled="disabled"
  >
    <icon
      v-if="icon"
      :path="icon"
      :size="sizeIcon"
    />
    <span
      v-if="label"
      :class="labelClass"
    >{{ label }}</span>
  </component>
</template>
